import React from 'react';
import { CTAButton } from '../CTAButton';
export function LimitedAvailability() {
  return <div className="space-y-6" data-id="element-215">
      <h2 className="text-3xl font-bold text-gray-900" data-id="element-216">
        Why You Should Order Soon
      </h2>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-217">
        Due to the FDA-compliant medical-grade manufacturing requirements for
        the hollow microneedles, production is extremely limited.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-218">
        Each device must be manufactured in a certified clean room
        environment—the same type of facility used for surgical instruments and
        injectable medications. This ensures every microneedle is perfectly
        formed, contamination-free, and safe for penetrating your skin barrier.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-219">
        The sterile serum cartridges also require specialized aseptic filling
        processes to maintain their clinical-grade potency without
        preservatives.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-220">
        This level of quality control means they can only produce limited
        quantities each month.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-221">
        In the past three months, they've sold out twice and customers had to
        wait 4-6 weeks for restock.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-222">
        If you're interested in trying this device, I recommend ordering while
        it's available.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-223">
        With the 64% discount currently running, stock moves even faster.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-224">
        The 30-day guarantee means you're covered—but you can only try it if you
        can actually get one.
      </p>
      <div className="py-4" data-id="element-225">
        <CTAButton data-id="element-226">APPLY DISCOUNT & CHECK AVAILABILITY</CTAButton>
      </div>
    </div>;
}